module.exports = __webpack_public_path__ + "static/ghost-ca81fe3e7c5f8ae98fa0d7887fa6e575.jpeg";